module.exports = __webpack_public_path__ + "img/yz_7@2x.78cafed7.png";